import { ReactNode } from "react";
import styled from "styled-components";

interface IProps {
  error?: boolean;
  nextLine?: boolean;
  success?: boolean;
  message?: string | ReactNode;
  additionLength?: number;
  className?: string;
  onClick?: (data: unknown) => void;
  children?: ReactNode;
  updateEmail?:boolean;
  workspace?:boolean;
}

const Content = styled.label<{ additionLength?: number | string ; updateEmail?: boolean; workspace?:boolean;}>`
  display: block;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: ${({ theme }) => theme.textColor};
  padding-bottom: ${({ updateEmail, workspace }) => ((updateEmail || workspace) ? 0 : "5px")};
  width: calc(
    100% +
      ${({ additionLength, workspace }) =>
        additionLength === 0 || additionLength ? additionLength : workspace? 10 : 30}px
  );

  & a {
    text-decoration: underline;
    color: ${({ theme }) => theme.primaryColor};
  }
`;

const MessageText = styled.span<Pick<IProps, "error" | "success"  | "workspace">>`
  white-space: break-spaces;
  color: ${(props) =>
    props.error
      ? props.theme.dangerColor
      : props.success
      ? props.theme.successColor
      : props.theme.greyColor40};
  font-size: 13px;

   ${(props) =>
    props.workspace &&
    `@media (max-width: 576px) {
      font-size: 11px;
    }`}
`;

const Label = (props: IProps) => (
  <Content
    additionLength={props.additionLength}
    updateEmail={props.updateEmail}
    workspace={props. workspace}
    className={props.className}
    onClick={props.onClick}
  >
    {props.children}
    {props.message && (
      <span>
        {props.children ? props.nextLine ? <br /> : " - " : null}
        <MessageText error={props.error} workspace={props.workspace} >{props.message}</MessageText>
      </span>
    )}
  </Content>
);

export default Label;